/**
 * Traffic sources' two tabs: Sources (which channels bring customers and
 * money) and Website (how people behave on syncsuite.co). One page since
 * 2026-10-28; the tab lives in the address (?tab=website).
 */
import { useSearchParams } from "react-router-dom";
import { Globe, Waypoints } from "lucide-react";
import { cn } from "@/lib/utils";

export type TrafficTab = "sources" | "website";

export function TrafficTabs({ active }: { active: TrafficTab }) {
  const [, setParams] = useSearchParams();
  const go = (t: TrafficTab) => {
    if (t === active) return;
    setParams(t === "website" ? { tab: "website" } : {});
  };
  const tabs: { k: TrafficTab; label: string; hint: string; icon: typeof Globe }[] = [
    { k: "sources", label: "Sources", hint: "Which channels bring customers and money", icon: Waypoints },
    { k: "website", label: "Website", hint: "How people use syncsuite.co", icon: Globe },
  ];
  return (
    <div className="flex items-center gap-1 border-b border-zinc-800/60" role="tablist">
      {tabs.map((t) => (
        <button
          key={t.k}
          type="button"
          role="tab"
          aria-selected={active === t.k}
          title={t.hint}
          onClick={() => go(t.k)}
          className={cn(
            "-mb-px inline-flex cursor-pointer items-center gap-1.5 border-b-2 px-3 py-2 text-sm font-medium transition-colors",
            active === t.k ? "border-indigo-500 text-zinc-100" : "border-transparent text-zinc-400 hover:text-zinc-200",
          )}
        >
          <t.icon className="h-3.5 w-3.5" />
          {t.label}
        </button>
      ))}
    </div>
  );
}
